import api from '../../config/axios.js';

const state = {
    payload: null,
    loading: false,
    error: '',
};

const getters = {
    getFinancialAdvisor: state => state.payload,
    getFinancialAdvisorLoading: state => state.loading,
    getFinancialAdvisorError: state => state.error,
};

const actions = {
    async fetchFinancialAdvisor({ commit }, goalId = null) {
        commit('setFinancialAdvisorLoading', true);
        commit('setFinancialAdvisorError', '');
        try {
            const params = goalId ? { goal_id: goalId } : {};
            const response = await api.axios.get('/api/finance/ai-advisor', { params });
            commit('setFinancialAdvisor', response.data || null);
            return response.data;
        } catch (error) {
            if (api.axios.isCancel(error)) return;
            commit('setFinancialAdvisorError', error?.response?.data?.message || 'Não foi possível carregar seu planejamento.');
            throw error;
        } finally {
            commit('setFinancialAdvisorLoading', false);
        }
    },
};

const mutations = {
    setFinancialAdvisor(state, payload) { state.payload = payload; },
    setFinancialAdvisorLoading(state, loading) { state.loading = loading; },
    setFinancialAdvisorError(state, error) { state.error = error; },
};

export default { state, getters, actions, mutations };
